<template>
  <div class="flex-al-start flex-jc-bt pd-l-20 pd-r-20 pd-t-20 table-info text-left">
    <div class="flex-1 left-side text-center">
      <SpCard type="none">
        <div class="card-content">
          <SpForm v-model="filterForm" @submit="search">
            <div class="buttons flex-al-center">
              <div style="width: 200px">
                <SpButton type="warn" width="163" height="44" :bold="400" :font="18" circle-radius="20" to="addFaqs">{{ $l('Add New') }}</SpButton>
              </div>
              <div class="flex-1 flex-al-start flex-jc-bt flex-jc-start">
                <div class="flex-al-start mg-r-30">
                  <span class="mg-r-20">{{ $l('Category') }}</span>
                  <!--                  <SpInput v-model="filterForm.name" name="name" type="grayBorder18" :validate-reg="/^(?=.*[a-zA-Z])[A-Za-z0-9\-.\' ]{3,64}$/" :width="230" :height="42" /> -->
                  <SpSelect v-model="filterForm.typeId" :show-clear="true" style="display: inline-block"
                            :need-search="false" strategy="fixed"
                            type="grayBorder18"
                            width="230" height="42">
                    <SpSelectOption v-for="op in questionOptions" :key="op.id" :disabled="![142, 143].includes(op.id)" :label="op.name" :value="op.id" />
                  </SpSelect>
                </div>
                <div class="flex-al-center mg-r-30">
                  <span class="mg-r-20">{{ $l('Source') }}</span>
                  <SpSelect v-model="filterForm.source" :show-clear="true" style="display: inline-block"
                            :need-search="false" strategy="fixed"
                            type="grayBorder18"
                            width="230" height="42">
                    <SpSelectOption label="Shiplus" value="0" />
                    <SpSelectOption label="individual" value="1" />
                    <SpSelectOption label="Shipowner" value="3" />
                    <SpSelectOption label="Charterer" value="4" />
                    <SpSelectOption label="Broker" value="5" />
                    <SpSelectOption label="OP" value="6" />
                  </SpSelect>
                </div>
                <div class="flex-al-center mg-r-30">
                  <span class="mg-r-20">{{ $l('Key Words') }}</span>
                  <SpInput v-model="filterForm.keyWord" name="keyWord" :validate-reg="/^(?=.*[a-zA-Z])[A-Za-z0-9\-.\' ]{1,64}$/" type="grayBorder18" :width="230" :height="42" />
                </div>
                <SpButton :width="110" :height="42" circle-radius="10" type="primary" :bold="400" :font="18" :label="$L('Search')" html-type="submit" />
              </div>
            </div>
          </SpForm>

          <SpTableDIY v-model:currPage="currPage" width="1" :data-list="dataList" :total="total" :page-size="pageSize"
                      show-arrow column-height="91" class="mg-t-20" @afterExpand="expand">
            <SpTableColumn column-name="id" label="No" width="70" />
            <SpTableColumn label="QuestionsCategory" width="260">
              <template #default="row">
                <div class="ellipsis pd-l-20 pd-r-20">{{ row.type?.name }}</div>
              </template>
            </SpTableColumn>
            <SpTableColumn column-name="subject" width="200" label="Subject" />
            <SpTableColumn column-name="keyWords" width="200" label="IndexKeywords" />
            <SpTableColumn column-name="description" label="QuestionDescription" width="580" />
            <SpTableColumn label="Action" width="100">
              <template #default="row">
                <div v-if="type==='all'" class="actions-td flex-jc-center">
                  <router-link :to="{path:'/cargoOwner/cargo/charteringOrder/addNew'}">
                    <span class="font20 icon-look iconfont mg-r-20 sp-color-18" />
                  </router-link>
                  <span v-if="row.employerId !== $store.state.user.user.employerId && !row.followed"
                        class="icon-heart iconfont pointer-no sp-color-7" style="font-size: 22px; "
                        @click="followQuestion(row, row.$index)" />
                  <span v-else-if="row.employerId == $store.state.user.user.employerId "
                        class="icon-heart iconfont pointer-no sp-color-7" style="font-size: 22px; cursor: not-allowed;opacity: 0.7" />
                  <span v-else
                        class="icon-heart iconfont pointer-no sp-color-7" style="font-size: 22px; color: red" />
                </div>
              </template>
            </SpTableColumn>
            <template #expand="row">
              <div class="expand flex">
                <div class="flex-align-center flex-col">
                  <!--                  :to="{ name: 'addStaff', params:{ type: 'employment' },query: {deptId: row.id} }" -->
                  <router-link
                    :to="{ name: 'addStaff', params:{ type: 'employment' },query: {} }"
                    class="link sp-color-6">
                    {{ $l('FeedBack (20)  ') }}
                  </router-link>
                  <!--                  v-model="row.showFollowedHistory" -->
                  <SpPopover :width="650">
                    <template #reference>
                      <SpProgress
                        :progress="9"
                        :border="false"
                        class="sp-color-bg-5"
                        width="167"
                      />
                      <!--                      @click="row.showFollowedHistory = !row.showFollowedHistory" -->
                    </template>
                    xxxx
                  </SpPopover>
                  <div class="sp-color-7">25th May 2020 1528</div>
                </div>
              </div>
            </template>
          </SpTableDIY>
        </div>
      </SpCard>
    </div>
    <div style="width: 280px" class="mg-l-30 pd-20 right-side sp-color-bg-4">
      <SpTableDIY :data-list="dataList" column-height="91" hide-pagination>
        <SpTableColumn label="EnteredBy" column-height="91">
          <template #default="row">
            <div class="fs-int title" style="font-weight: 600">{{ row.questionerCorpName }}</div>
            <div class="attach fs-int opacity-60" style="font-weight: 600">{{ row.questionerName }}</div>
            <div class="attach fs-int" style="font-weight: 600">{{ getDateToFormatEn(row.createdAt) }}</div>
          </template>
        </SpTableColumn>
        <template #expand>
          <div class="expand" />
        </template>
      </SpTableDIY>
    </div>
  </div>
</template>

<script>
import SpCard from '@/components/common/SpCard'
import SpTag from '@/components/common/SpTag'
import SpTagGroup from '@/components/common/SpTagGroup.vue'
import SpTableDIY from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn.vue'
import { reactive, ref, watch } from 'vue'
import SpButton from '../../common/SpButton'
import _debounce from 'lodash/debounce'
import SpDialog from '@/components/common/SpDialog'
import { getDateToFormatEn } from '@/utils/convert'
import SpPopover from '../../common/SpPopover'
import SpProgress from '../../common/SpProgress'
import {
  followedQuestionApi,
  followedQuestionListApi,
  getQuestionTypeOptionApi,
  questionDeleteApi,
  questionSearchApi
} from '../../../request/APIs/sharing'
import { computed } from '@vue/runtime-core'
import { useStore } from 'vuex'
import SpMessage from '@/components/common/SpMessage'
import SpForm from '../../common/SpForm'
import SpInput from '../../common/SpInput'
import SpSelect from '../../common/SpSelect'
import SpSelectOption from '../../common/SpSelectOption'
export default {
  name: 'AnswersCenterIndex',
  components: {
    SpSelectOption,
    SpSelect,
    SpInput,
    SpForm,
    SpProgress,
    SpPopover,
    SpButton,
    SpCard,
    SpTag,
    SpTagGroup,
    SpTableDIY,
    SpTableColumn
  },

  setup (props, ctx) {
    const store = useStore()
    const userType = computed(() => store.state.user.user.employerId)

    const type = ref('all')
    const dataList = ref([])
    const popoverVisible = ref(false)

    const delInfo = ref({})
    const showPopover = _debounce((row) => {
      delInfo.value = {

      }
    }, 300)
    const filterForm = reactive({})

    // 获取列表
    const pageSize = ref(15)
    const total = ref(0)
    const currPage = ref(1)
    const getMore = () => {
      questionSearchApi(filterForm.typeId, filterForm.source, filterForm.keyWord, currPage.value).then(res => {
        dataList.value = res.data.data
        pageSize.value = res.data.pageSize
        total.value = res.data.total
      })
    }
    getMore()

    // 列表类型切换
    const changeType = (type) => {
      currPage.value = 1
      getMore()
    }
    watch(() => currPage.value, (val) => {
      getMore()
    })

    const search = (formData, form) => {
      currPage.value = 1
      getMore()
    }
    const questionOptions = ref([])
    getQuestionTypeOptionApi().then(res => {
      questionOptions.value = Object.values(res.data)
    })
    const followQuestion = (item, index) => {
      followedQuestionApi(item.id).then(res => {
        if (res.code === 1) {
          SpMessage.success('Copy succeed!')
          dataList.value[index].followed = true
        }
      })
    }
    return {
      userType,
      type,
      dataList,
      delInfo,
      popoverVisible,
      showPopover,
      total,
      currPage,
      pageSize,
      filterForm,
      questionOptions,
      search,
      getMore,
      changeType,
      followQuestion,
      getDateToFormatEn
    }
  }
}
</script>

<style scoped lang="less">
.table-info{

  .column-attach{
    font-weight: 400;
    opacity: 0.6;
    margin: 0;
  }
  .left-side{
    overflow: hidden;
    .card-content{
      padding: @gap;
      position: relative;
      // overflow: hidden;
      .tags{
        margin-top: @gap;
      }
    }
    .actions-td{
      .iconfont {
        font-weight: 500;
      }
    }
    .table{
      font-weight: bold;
      color: black;
      margin-top: @gap;
      .column-main{
        margin: 0;
      }

      .expand-item{
        opacity: 0.5;
        font-weight: normal;
      }
      .progress-bar{
        width: 191px;
        height: 9px;
        background: #f2f2f2;

        margin: @gap/2 0 @gap/2 0;
        &.blue {
          background: #72BEDE;
        }
      }
    }
  }
  .right-side{
    background-color: white;
    padding: @gap @gap @gap @gap;
    margin: 103px @gap @gap @gap;
  }

  .expand{
    padding:@gap;
    height:60px;
  }
}
</style>
